import { render, staticRenderFns } from "./CompanyPolicy.vue?vue&type=template&id=35334599&scoped=true&"
import script from "./CompanyPolicy.vue?vue&type=script&lang=js&"
export * from "./CompanyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPolicy.vue?vue&type=style&index=0&id=35334599&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35334599",
  null
  
)

export default component.exports